import axiosInstance from "app/axios";
import { AxiosResponse } from "axios";
import { AgentInterface } from "interfaces/Agent";
import { UserRoles } from "interfaces/UserRoles";

export interface fetchAgentListArgument {
  items_per_page: number | 'unlimited';
  page?: number;
  search?: string;
  endpoint?: UserRoles;
}

export interface AgentsResponseInterface {
  data: {
    total: number;
    pages: number;
    agents: AgentInterface[];
  };
}

export function fetchAgentList({ items_per_page,page, search, endpoint = UserRoles.Admin }: fetchAgentListArgument): Promise<AxiosResponse<AgentsResponseInterface, any>> {
  const params:any = {items_per_page};
  if (page) params.page = page;
  if (search) params.search = search;
  
  return axiosInstance.get(`${endpoint}/agents`, {
    params,
  });
}
